import HorizontalScroll from "@Components/HorizontalScroll";
import Subsection from "../Subsection";
import styles from "./ReferralProgram.module.scss";
import ReferralProgramCard from "./components/ReferralProgramCard";
import config from "@Config/index";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import {
  DESKTOP_APP_URL_HOME_PAGE_OFFER_SECTION,
  MOBILE_APP_URL_HOME_PAGE_OFFER_SECTION,
} from "constants/configConstants";
import useTranslationHook from "hooks/useTranslationHook";
import useIsLanguage from "hooks/useIsLanguage";
import wrapperHOC from "@Utils/wrapperHOC";
import getAppLink from "@Utils/getAppLink";
import useIsApp from "hooks/useIsApp";
import { SCREEN_SIZE, useResponsiveness } from "hooks/useResponsiveness";

const ReferralProgram = ({ isDesktop = false }) => {
  const { t } = useTranslationHook();
  const language = useIsLanguage();
  const isApp = useIsApp();
  const { isAbove } = useResponsiveness();
  const isAboveMD = isAbove(SCREEN_SIZE.MD, false);
  const showForDesktop = isDesktop && isAboveMD;
  const referSecTitle = t("home.reffralprogram.refferaltitle");
  const referSecSubTitle = t("home.reffralprogram.promotions.subtitle");
  const scholarshipCardTitle = t("home.reffralprogram.scholarship.cardtitle");
  const scholarshipCardSubTitleOne = t("home.reffralprogram.scholarship.cardsubtitleone");
  const scholarshipCardSubTitleTwo = t("home.reffralprogram.scholarship.cardsubtitletwo");
  const scholarshipCardCTA = t("home.reffralprogram.scholarship.cardcta");
  const referCardTitleOne = t("home.reffralprogram.referralcard.titleone");
  const referCardSubtitleOne = t("home.reffralprogram.referralcard.subtitleone");
  const referCardSubtitleTwo = t("home.reffralprogram.referralcard.subtitletwo");
  const referCardCTA = t("home.reffralprogram.referralcard.cta");
  const amberPlusTitle = t("home.reffralprogram.amberplus.title");
  const amberPlusSubTitleOne = t("home.reffralprogram.amberplus.subtitleone");
  const amberPlusSubTitleTwo = t("home.reffralprogram.amberplus.subtitletwo");
  const amberPlusCTA = t("home.reffralprogram.amberplus.cta");
  const appTitle = t("home.reffralprogram.appoffer.title");
  const appSubTitle = t("home.reffralprogram.appoffer.subtitle");
  const appCTA = t("home.reffralprogram.appoffer.cta");

  return (
    <Subsection
      title={referSecTitle}
      subtitle={referSecSubTitle}
      withSidePadding={showForDesktop}
      subSectionPaddingReduced={!showForDesktop}
      greyBg
      isDesktop={showForDesktop}
      hideBottomBorder
      noMarginBottom
    >
      {showForDesktop ? (
        <HorizontalScroll
          showControls
          className={formatClassNames(styles.horizontalScroll, showForDesktop && styles.desktop)}
        >
          <ReferralProgramCard
            index={1}
            testId="Refer"
            title={<>{referCardTitleOne}</>}
            gtagTitle="Refer a friend, and you both get £50"
            subtitle={
              <>
                {referCardSubtitleOne}
                <br />
                {referCardSubtitleTwo}
              </>
            }
            ctaText={referCardCTA}
            href="/referral-programme?utm_source=home_page"
            bgSrc={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/Offer-Card-01.png?q=90`}
            isDesktop
          />
          <ReferralProgramCard
            index={2}
            testId="Scholarships"
            title={scholarshipCardTitle}
            gtagTitle="Unlock up to $15,000 in Scholarships!"
            subtitle={
              config.IS_CHINA_APP ? (
                <>
                  {scholarshipCardSubTitleOne}
                  <br />
                  {scholarshipCardSubTitleTwo}
                </>
              ) : (
                <>
                  {scholarshipCardSubTitleOne} <br />
                  {scholarshipCardSubTitleTwo}
                </>
              )
            }
            ctaText={scholarshipCardCTA}
            href="/scholarship?utm_source=home_page"
            bgSrc={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/Offer-Card-04.png?q=90`}
            isDesktop
            openInExternalBrowser
          />
          {config.IS_CHINA_APP && (
            <ReferralProgramCard
              index={3}
              testId="Amber-plus"
              title={
                language !== "en" ? (
                  amberPlusTitle
                ) : (
                  <>
                    Save up to <span className={styles.redText}>£1500</span> with amber
                    <span className={styles.redText}>+</span>
                  </>
                )
              }
              gtagTitle="Save up to £1500 with amber+"
              subtitle={
                config.IS_CHINA_APP ? (
                  <>
                    {amberPlusSubTitleOne} <br /> {amberPlusSubTitleTwo}
                  </>
                ) : (
                  <>
                    {t("home.reffralprogram.amberplus.subtitleone")}
                    <br />
                    {t("home.reffralprogram.amberplus.subtitletwo")}
                  </>
                )
              }
              ctaText={amberPlusCTA}
              href="/plus?utm_source=home_page"
              bgSrc={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/Offer-Card-03.png?q=90`}
              isDesktop
            />
          )}
          <ReferralProgramCard
            index={4}
            testId="App"
            title={
              config.IS_CHINA_APP ? (
                appTitle
              ) : (
                <>
                  {t("home.reffralprogram.appoffer.titleone")}{" "}
                  {t("home.reffralprogram.appoffer.titletwo")}
                </>
              )
            }
            gtagTitle="Get additional £20 cashback on your booking!"
            subtitle={
              config.IS_CHINA_APP ? (
                appSubTitle
              ) : (
                <>
                  {t("home.reffralprogram.appoffer.subtitleone")}{" "}
                  {t("home.reffralprogram.appoffer.subtitletwo")}
                </>
              )
            }
            ctaText={appCTA}
            href={getAppLink(DESKTOP_APP_URL_HOME_PAGE_OFFER_SECTION)}
            bgSrc={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/Offer-Card-02.png?q=90`}
            isDesktop
          />
        </HorizontalScroll>
      ) : (
        <HorizontalScroll className={styles.horizontalScroll}>
          <ReferralProgramCard
            testId="Refer"
            index={1}
            title={<>{referCardTitleOne}</>}
            gtagTitle="Refer a friend, and you both get £50"
            subtitle={
              <>
                {referCardSubtitleOne}
                <br />
                {referCardSubtitleTwo}
              </>
            }
            ctaText={referCardCTA}
            href="/referral-programme?utm_source=home_page"
            bgSrc={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/refer1.png?q=90`}
          />
          <ReferralProgramCard
            testId="Scholarships"
            ctaText={scholarshipCardCTA}
            index={2}
            title={scholarshipCardTitle}
            gtagTitle="Unlock up to $15,000 in Scholarships!"
            subtitle={
              config.IS_CHINA_APP ? (
                <>
                  {scholarshipCardSubTitleOne} <br />
                  {scholarshipCardSubTitleTwo}
                </>
              ) : (
                <>
                  {scholarshipCardSubTitleOne} <br />
                  {scholarshipCardSubTitleTwo}
                </>
              )
            }
            openInExternalBrowser={isApp}
            getLocalizedPath
            href="/scholarship?utm_source=home_page"
            bgSrc={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/refer4.png?q=90`}
          />
          {config.IS_CHINA_APP && (
            <ReferralProgramCard
              testId="Amber-plus"
              index={3}
              title={
                language !== "en" ? (
                  amberPlusTitle
                ) : (
                  <>
                    Save up to <span className={styles.redText}>£300</span> with amber
                    <span className={styles.redText}>+</span>
                  </>
                )
              }
              gtagTitle="Save up to £300 with amber+"
              subtitle={
                config.IS_CHINA_APP ? (
                  <>
                    {amberPlusSubTitleOne} <br /> {amberPlusSubTitleTwo}
                  </>
                ) : (
                  <>
                    {t("home.reffralprogram.amberplus.subtitleone")}
                    <br />
                    {t("home.reffralprogram.amberplus.subtitletwo")}
                  </>
                )
              }
              ctaText={amberPlusCTA}
              href="/plus?utm_source=home_page"
              bgSrc={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/refer3.png?q=90`}
              openInExternalBrowser={isApp}
              getLocalizedPath
            />
          )}
          {!isApp && (
            <ReferralProgramCard
              testId="App"
              index={4}
              title={
                config.IS_CHINA_APP ? (
                  appTitle
                ) : (
                  <>
                    {t("home.reffralprogram.appoffer.titleone")}{" "}
                    {t("home.reffralprogram.appoffer.titletwo")}
                  </>
                )
              }
              gtagTitle="Get additional £20 cashback on your booking!"
              subtitle={
                config.IS_CHINA_APP ? (
                  appSubTitle
                ) : (
                  <>
                    {t("home.reffralprogram.appoffer.subtitleone")}{" "}
                    {t("home.reffralprogram.appoffer.subtitletwo")}
                  </>
                )
              }
              ctaText={appCTA}
              href={getAppLink(MOBILE_APP_URL_HOME_PAGE_OFFER_SECTION)}
              bgSrc={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/refer2.png?q=90`}
            />
          )}
        </HorizontalScroll>
      )}
    </Subsection>
  );
};

export default wrapperHOC(ReferralProgram, {
  componentName: "ReferralProgram-Home",
  showForChina: true,
  showForMiniProgram: false,
});
